export default function QuickPrompts({ prompts, currentIndex, onJump, onPlan }) {
  if (!prompts.length) return (
    <div className="text-[10px] text-slate-600 text-center py-2">No confluences yet — advance bars or change TF.</div>
  );
  return (
    <div data-testid="quick-prompts" className="space-y-1 max-h-44 overflow-y-auto pr-1">
      {prompts.slice().reverse().map(p => {
        const isLong = p.direction === "long";
        return (
          <div key={`p-${p.index}`} className={`group flex items-center gap-2 px-2 py-1.5 rounded border text-[10px] font-mono cursor-pointer transition-all ${isLong ? "border-emerald-500/30 bg-emerald-500/5 hover:bg-emerald-500/10" : "border-rose-500/30 bg-rose-500/5 hover:bg-rose-500/10"} ${p.index === currentIndex ? "ring-1 ring-blue-400/60" : ""}`}
               onClick={() => onJump(p.index)} data-testid={`prompt-${p.index}`}>
            <span className={`px-1.5 py-0.5 rounded text-[9px] font-bold ${isLong ? "bg-emerald-600 text-white" : "bg-rose-600 text-white"}`}>
              {isLong ? "LONG" : "SHORT"}
            </span>
            <div className="flex-1 min-w-0">
              <div className="flex justify-between text-slate-300">
                <span className="truncate">{p.concepts.join(" + ")}</span>
                <span className="text-slate-500">#{p.index}</span>
              </div>
              <div className="text-slate-500 text-[9px]">
                @ {p.price.toFixed(2)} · {p.region} · score {p.score}
              </div>
            </div>
            <button onClick={(e) => { e.stopPropagation(); onPlan(p); }}
              className="opacity-0 group-hover:opacity-100 text-[9px] font-bold px-1.5 py-0.5 rounded bg-blue-600 hover:bg-blue-700 text-white transition-opacity">
              PLAN
            </button>
          </div>
        );
      })}
    </div>
  );
}
